export default __webpack_public_path__ + "static/media/sar.68d3ad48.PNG";